'use client';
import { useEffect } from 'react';

import { Analytics } from '@monoimin/utils/analytics';
import { useLocale } from '@monoimin/intl';

import type { C2AAnalyticsClientProps } from '@monoimin/sb-types';

interface ClientClickOnServerLinkElementProps {
  id: string;
  data: C2AAnalyticsClientProps;
  actionName: string;
}
export const ClientClickOnServerLinkElement = ({
  id,
  data,
  actionName,
}: ClientClickOnServerLinkElementProps) => {
  const locale = useLocale();
  useEffect(() => {
    // берем элемент по id
    const element = document.getElementById(id);

    if (element) {
      // находим внутри элемента первый тег 'a'
      const aTag = element.querySelector('a');

      if (aTag) {
        // добавляем событие клика на тег 'a'
        aTag.addEventListener('click', () => {
          const finalData: C2AAnalyticsClientProps = {
            ...data,
            language: locale,
            block_element_click: 'button',
            event_type: 'click',
          };
          const renta = new Analytics();
          renta.track(actionName, finalData);

          if (typeof window !== 'undefined' && window?.dataLayer?.push) {
            window.dataLayer.push({
              event: 'block_clicks',
              cta_block_category: data.block_type,
              cta_block_name: data.block_name as string,
              attribute_name: data.element_click_description as string,
              attribute_url: data.element_click_url as string,
            });
          }
        });
      }
    }
  }, [id]);
  return null;
};
